__turbopack_context__.v({
  "online": "index-module-scss-module__axB4Fq__online",
  "presence_status": "index-module-scss-module__axB4Fq__presence_status",
});
